document.addEventListener("DOMContentLoaded", function() {
    const swiper = new Swiper(".sponsors__slider", {
    spaceBetween: 40,
    speed:3500,
    direction: 'horizontal',
    autoplay: {delay: 0},
    loop: true,
    slidesPerView: 1,
    freeMode: true,

    breakpoints: {           
      0: { slidesPerView:2 },
      576: { slidesPerView: 2 },
      768: { slidesPerView: 3 },
      992: { slidesPerView: 4 }
    }
  });
});